import React from 'react';

function About() {
  return (
    <div className="about">
      <div className="about-container">
        <h1 className="section-title">About Invex</h1>
        <p className="section-subtitle">
          Building the future of business management for Saudi Arabia
        </p>

        <div className="about-content">
          <h3>Our Mission</h3>
          <p>
            At Invex, we're dedicated to empowering small and medium-sized businesses across Saudi Arabia 
            with powerful, easy-to-use technology. Our flagship product, Invex, was built from the ground 
            up to address the unique challenges faced by restaurants, cafes, grocery stores, and retail 
            establishments in the Saudi market.
          </p>

          <h3>Why Invex?</h3>
          <p>
            We recognized that business owners were juggling multiple systems - separate tools for point 
            of sale, inventory tracking, supplier management, and accounting. This fragmentation led to 
            inefficiencies, errors, and lost opportunities. Invex brings everything together in one 
            comprehensive, intuitive platform.
          </p>

          <h3>Built for Saudi Arabia</h3>
          <p>
            Invex isn't just another business management tool - it's specifically designed for the Saudi 
            market with features that matter:
          </p>
          <ul>
            <li>Full Arabic language support with right-to-left (RTL) interface</li>
            <li>Automatic 15% VAT calculation and compliance</li>
            <li>ZATCA-compliant QR codes for e-invoicing regulations</li>
            <li>Integration with popular thermal printers used in Saudi businesses</li>
            <li>Multi-location support for growing Saudi enterprises</li>
            <li>Local customer support that understands your business</li>
          </ul>

          <h3>Our Technology</h3>
          <p>
            Invex is built using cutting-edge technology to ensure reliability, security, and performance:
          </p>
          <ul>
            <li>Cloud-based infrastructure for access anywhere, anytime</li>
            <li>Real-time data synchronization across all devices</li>
            <li>Bank-level security with encrypted data transmission</li>
            <li>Automatic backups to protect your business data</li>
            <li>Optimized for mobile, tablet, and desktop devices</li>
          </ul>

          <h3>Our Commitment</h3>
          <p>
            We're committed to continuous improvement and innovation. Our development team regularly 
            releases updates based on customer feedback, ensuring Invex evolves with your business needs. 
            We provide comprehensive training resources, responsive customer support, and ongoing guidance 
            to help you get the most out of the platform.
          </p>

          <h3>Trusted by Saudi Businesses</h3>
          <p>
            Since our launch, we've helped over 50 businesses across Saudi Arabia streamline their 
            operations, reduce costs, and increase profitability. From small family-owned cafes to 
            multi-location retail chains, Invex scales to meet your needs.
          </p>

          <h3>Join the Invex Community</h3>
          <p>
            Whether you're opening your first store or managing multiple locations, Invex provides the 
            the difference that comprehensive business management can make.
          </p>
        </div>

        <div style={{ marginTop: '3rem', textAlign: 'center' }}>
          <a href="/contact" className="btn btn-primary">Get in Touch</a>
          <a href="/pricing" className="btn btn-secondary" style={{ marginLeft: '1rem' }}>View Pricing</a>
        </div>
      </div>
    </div>
  );
}

export default About;
